module.exports = __webpack_public_path__ + "static/media/Picker_specifiques_elN318_1395429857.19272317.png";